import React, {
  FunctionComponent,
  LiHTMLAttributes,
  SyntheticEvent,
} from 'react';

import BaseDropdownItem from '../BaseDropdownItem';
import styleClassNames from './styles.module.scss';

interface ListDropdownItemProps {
  name: Name;
  isArrowed?: boolean;
  isDisabled?: boolean;
  isSelected?: boolean;
  isTabbable?: boolean;
  onChoose?: (name: Name, e?: SyntheticEvent) => void;
}

type Name = string | number;

const ListDropdownItem: FunctionComponent<ListDropdownItemProps & LiHTMLAttributes<HTMLLIElement>> = (
  props
) => {
  const baseProps = {
    ...props,
    styleClassNames,
    variantName: 'list',
  };

  return <BaseDropdownItem {...baseProps} />;
};

export default ListDropdownItem;
